import { render } from "./video-full-sec.vue?vue&type=template&id=7b0421bd&scoped=true"
import script from "./video-full-sec.vue?vue&type=script&lang=js"
export * from "./video-full-sec.vue?vue&type=script&lang=js"

import "./video-full-sec.vue?vue&type=style&index=0&id=7b0421bd&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0421bd"]])

export default __exports__